import { Route } from '@angular/router';
import {
  splUiComingSoonFeatureRoute,
  splUiNotFoundFeatureRoute,
  splUiThemePreviewFeatureRoute,
} from '@splitory/splitory-ui';
import { authOnlyGuard } from '@app/core/guards';

export const appRoutes: Route[] = [
  splUiComingSoonFeatureRoute,
  {
    path: '',
    loadChildren: () => import('./shells/app').then((m) => m.appShellRoutes),
    canActivate: [authOnlyGuard],
  },
  {
    path: '',
    loadChildren: () => import('./shells/public').then((m) => m.publicShellRoutes),
  },
  splUiThemePreviewFeatureRoute,
  splUiNotFoundFeatureRoute(),
];
